import type { ComponentType, ReactNode } from 'react';
import { X } from 'lucide-react';
import { cn } from '@/lib/utils';

interface WidgetCardProps {
  widgetId: string;
  mode: 'view' | 'edit';
  Component: ComponentType;
  onRemove?: (widgetId: string) => void;
  children?: ReactNode;
}

/**
 * Wrapper que aplica overlay de edicao em cima do componente do widget.
 * Em view mode renderiza o card tal como o dashboard estatico antigo.
 * Em edit mode adiciona borda tracejada, cursor de grab e botao X.
 */
export function WidgetCard({
  widgetId,
  mode,
  Component,
  onRemove,
}: WidgetCardProps) {
  return (
    <div
      className={cn(
        'relative h-full w-full overflow-hidden',
        mode === 'edit' &&
          'cursor-grab select-none rounded-xl outline outline-2 outline-dashed outline-[var(--accent)]/50',
      )}
    >
      <div
        className={cn(
          'h-full w-full',
          mode === 'edit' && 'pointer-events-none',
        )}
      >
        <Component />
      </div>
      {mode === 'edit' && (
        <button
          type="button"
          onMouseDown={(e) => e.stopPropagation()}
          onTouchStart={(e) => e.stopPropagation()}
          onClick={(e) => {
            e.stopPropagation();
            onRemove?.(widgetId);
          }}
          aria-label="Remover widget"
          className={cn(
            'absolute right-2 top-2 z-10 inline-flex h-7 w-7 items-center justify-center rounded-full',
            'bg-[var(--surface)] text-[var(--fg)] shadow-md ring-1 ring-[var(--border)]',
            'hover:bg-[var(--danger,#ef4444)] hover:text-white',
          )}
        >
          <X className="h-4 w-4" />
        </button>
      )}
    </div>
  );
}
